import { doRequest } from '@r1-frontend/do-request';
import { selectTimeSlot } from '@r1-frontend/api-domru/full-buy/v1/sale-agent/select-time-slot';
import { RequestDto } from '@r1-frontend/api-domru/full-buy/v1/sale-agent/select-time-slot/dto/RequestDto';
import { ResponseDto } from '@r1-frontend/api-domru/full-buy/v1/sale-agent/select-time-slot/dto/ResponseDto';

import { ESaleAgentClientName } from '@r1-frontend/service-engineer-visit';

import { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult';
import getProviderId from '@r1-frontend/shared/helpers/getProviderId';

import { speedBonusConnectionAnalytics } from '~/src/entities/speed-bonus/analytics';
import { TContextDispatch } from '~/src/entities/speed-bonus/context';
import { setResult, toggleIsLoading } from '~/src/entities/speed-bonus/context/actions';
import { TInitialState } from '~/src/entities/speed-bonus/context/reducer';

export const confirmTimeSlot = () => async(dispatch: TContextDispatch, getState: () => TInitialState) => {
    const providerId = Number(getProviderId());

    const { businessLogic, timeSlotData } = getState();

    if (!businessLogic?.agreementId || !timeSlotData) {
        return;
    }

    dispatch(toggleIsLoading(true));

    const reqParams: RequestDto = {
        agreementId: businessLogic.agreementId,
        dateFrom: `${timeSlotData.date} ${timeSlotData.hour}`,
        saleAgentClientName: ESaleAgentClientName.FULL_BUY_EQUIPMENT_SITE,
        info: timeSlotData.comment,
    };

    const response = await doRequest.fullBuy<ResponseDto>(
        selectTimeSlot(providerId, reqParams),
    );

    if (response.isSuccess) {
        speedBonusConnectionAnalytics.timeSlotSuccessConfirmed();

        const [hour, minutes] = timeSlotData.hour.split(':') || ['00', '00'];
        const timeSlotText = `${timeSlotData?.date} c&nbsp;${timeSlotData?.hour} до&nbsp;${String(Number(hour) + 1).padStart(2, '0')}:${minutes}`;

        dispatch(setResult({
            entity: 'request',
            status: EResultPopupStatus.SUCCESS,
            header: `Инженер придет ${timeSlotText}.`,
            message: 'Управляйте заявкой на&nbsp;странице Заявки и&nbsp;заказы',
        }));
    } else {
        speedBonusConnectionAnalytics.timeSlotConfirmationError();

        dispatch(setResult({
            entity: 'request',
            status: EResultPopupStatus.ERROR,
            header: 'Не&nbsp;удалось запланировать заявку на&nbsp;выбранную дату',
            message: 'Пожалуйста, попробуйте ещё раз. Если ошибка повторится&nbsp;&mdash; напишите нам в&nbsp;чат.',
        }));
    }

    dispatch(toggleIsLoading(false));
};
